<template>
    <form enctype="multipart/form-data" novalidate>
        <div class="dropbox">
            <div class="content-group-sm">
                <label for="file-upload" class="custom-file-upload btn btn-primary" :class="{'disabled': disabled}" :disabled="isSaving || disabled">
                    <i class="icon icon-upload"></i> {{label || 'Choose file'}}
                </label>
                <button class="btn btn-danger" @click="reset($event)" v-if="!isInitial">{{'Reset'}}</button>
                <br/><br/>
                <input id="file-upload" style="position:absolute; margin-top:-20px; visibility: hidden" type="file" ref="fileupload" :multiple="multiple" name="file" :disabled="isSaving || disabled" @change="filesChange($event.target.name, $event.target.files || $event.dataTransfer.files); fileCount = $event.target.files.length" :accept="accept" class="input-file">
            </div>
            <div class="content-group-sm" v-if="isSaving">
                <p class="text-semibold">
                    <i class="icon-spinner spinner"></i> Uploading {{ fileCount }} files...
                </p>
                <div class="progress progress-lg">
                    <div class="progress-bar" :style="{width: uploadProgress+'%'}">
                        <span class="sr-only">{{uploadProgress}}% Complete</span>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger" v-if="uploadError">{{uploadError}}</div>
            <div class="panel panel-white" v-if="isSuccess">
                <div class="panel-heading">
                    <h6 class="text-semibold panel-title">
                                    <i class="icon-folder6 position-left"></i>
                                    Upload completed ({{fileCount}} files) 
                                <a class="heading-elements-toggle"><i class="icon-more"></i></a>
                            </h6>
                </div>
                <div class="list-group no-border">
                    <a class="list-group-item" v-for="file in uploadResult">
                        <i class="icon-file-empty"></i> {{file.filename}} ({{file.size|bytes}})
                        <template v-if="file.width && file.height">(Image size in pixels, width: {{file.width}}, height: {{file.height}})</template>
                        <span class="label bg-slate" v-if="file.errors.length > 0" v-for="e in file.errors">{{e}}</span>
                        <span class="label bg-success-400" v-if="file.errors.length === 0">OK</span>
                        <span class="label bg-danger-400" v-if="file.errors.length > 0" @click="reset">ERROR - RESET</span>
                    </a>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;

export default {
    data() {
        return {
            uploadResult: [],
            uploadError: null,
            currentStatus: null,
            uploadProgress: 0,
            fileCount: 0
        }
    },
    props: {
        url: String,
        accept: String,
        multiple: Boolean,
        label: String,
        disabled: Boolean,
        onUploadCompleted: Function,
        onUploadProgress: Function
    },
    filters: {
        bytes: function(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        }
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        }
    },
    methods: {
        reset($event) {
            $event && $event.preventDefault()
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            const input = this.$refs.fileupload;
            input.type = 'text';
            input.type = 'file';
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;
            var self = this

            this.$api.uploadReq(this.url, formData, function(e, progress) {
                    self.uploadProgress = Math.round(progress)
                    self.onUploadProgress && self.onUploadProgress(e, progress)
                })
                .then(x => {
                    self.uploadResult = x.body.result
                    self.currentStatus = STATUS_SUCCESS;
                    self.onUploadCompleted && self.onUploadCompleted(x.body.result, x.body)
                })
                .catch(err => {
                    self.uploadError = err.body.error;
                    self.currentStatus = STATUS_FAILED;
                });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;

            // append the files to FormData
            Array
                .from(Array(fileList.length).keys())
                .map(x => {
                    formData.append(fieldName, fileList[x], fileList[x].name);
                });

            // save it
            this.save(formData);
        }
    },
    mounted() {
        this.reset();
    },
}
</script>
<style scoped>
#file-upload {
    display: none;
}

.custom-file-upload {
    /*border: 1px solid #ccc;*/
    display: inline-block;
    /*padding: 6px 12px;*/
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/common/FileUpload.vue